import React, { use, useEffect, useRef } from "react";
import { useCadastroMultaNaoAcompanhadaStore } from "stores/cadastroMultaNaoAcompanhadaStore";
import { formMultaNaoAcompanhadaSteps } from "./formMultaNaoAcompanhadaSteps";
import CardAvatar from "components/Card/CardAvatar";
import { Icon } from "@material-ui/core";
import GridItem from "components/Grid/GridItem";
import { serverApi } from "services/constante";
import api from "services/api";
import { FormStepIndicator } from "../FormStepIndicator";
import "../../../../assets/css/form-steps.css";

export function FormMultaNaoAcompanhada({ onSubmit, initialStep }) {
  const topRef = useRef(null);

  const resetCadastroStore = useCadastroMultaNaoAcompanhadaStore(state => state.reset);
  const currentStep = useCadastroMultaNaoAcompanhadaStore(state => state.currentStep);
  const setTemplates = useCadastroMultaNaoAcompanhadaStore(state => state.setTemplates);
  const setStep = useCadastroMultaNaoAcompanhadaStore(state => state.setStep);

  const onMount = async () => {
    try {
      const formdata = new FormData();
      formdata.append('function', "templates_nao_acompanhada");
      const response = await api.post(serverApi.urlPHP + '/peticao_template.php', formdata);
      const templates = response.data.templates;
      setTemplates(templates);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (topRef.current != null) {
      topRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [currentStep]);

  useEffect(() => {
    onMount();
    
    if (initialStep != null) {
      setStep(initialStep);
    } else {
      resetCadastroStore();
    }
  }, []);

  return (
    <>
      <div ref={topRef} />

      <div className="form-steps">
        {formMultaNaoAcompanhadaSteps.map((step, i) => (
          <FormStepIndicator 
            key={i}
            activeStep={currentStep}
            stepNumber={i}
            title={step.title}
          />
        ))}
      </div>

      <CardAvatar profile style={{ marginTop: "30px", marginBottom: "12px", textAlign: 'center', width: '60px' }}>
        <Icon style={{ fontSize: "50px" }}>directions_car</Icon>
      </CardAvatar>

      <GridItem xs={12} sm={12} md={12} lg={12}>
        {formMultaNaoAcompanhadaSteps.map((formStep, index) => {
          // exibir apenas o formulário ativo
          const isActive = currentStep === index;

          if (!isActive) {
            return <div key={index} /> 
          }

          return (
            <div key={index}>
              <h3 style={{ textAlign: "center", margin: 0 }}>
                {formStep.title}
              </h3>

              <formStep.FormComponent
                isActive={isActive}
                onFinalSubmit={onSubmit}
              />
            </div>
          );
        })}
      </GridItem>
    </>
  )
}